import { LoginUserRole } from '@/constants/merchant';
import { FakeCaptcha, LoginResult, UserInfo } from '@/types/login';
import { requestWrapper } from '@/utils/request';

// 获取验证码
export async function getCaptcha(body: { mobile: string }) {
  const params = new URLSearchParams();
  params.append('mobile', body.mobile);

  return requestWrapper<FakeCaptcha>('/api/admin/send_sms', {
    method: 'POST',
    data: body,
  });
}

// 登录
export async function login(body: { mobile: string; sms_code: string }) {
  return requestWrapper<LoginResult>('/api/admin/login', {
    method: 'POST',
    data: body,
  });
}

// 退出登录
export async function logout() {
  return requestWrapper<Record<string, any>>('/api/admin/logout', {
    method: 'POST',
  });
}

// 获取用户信息
export async function getUserInfo() {
  return requestWrapper<UserInfo>('/api/admin/detail', {
    method: 'GET',
    showError: false,
  }).then((res) => {
    return {
      ...res,
      // 是否是商家管理员
      isAdmin: res?.role_data?.role_type === LoginUserRole.Admin,
    };
  });
}

// 获取登录二维码id
export async function getLoginQrCodeId() {
  return requestWrapper<{ unique_id: string }>('/api/admin/generate_login_qr_code', {
    method: 'POST',
  });
}

// 轮询查询登录状态
export async function checkLoginQrCodeStatus(uniqueId: string) {
  return requestWrapper<{ status: string; token: string }>('/api/admin/check_qrcode_status', {
    method: 'GET',
    params: {
      unique_id: uniqueId,
    },
  });
}
